import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=2e39c6a4"
import script from "./CreateList.vue?vue&type=script&lang=js"
export * from "./CreateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports